import { MutationCache, QueryCache, QueryClient } from '@tanstack/react-query'
import { datadogLogs } from '@datadog/browser-logs'

import { ApiError } from './apiErrors'
import { isDatadogLogsEnabled } from './datadog'
import { QUERY_STALE_TIMES } from './queryConfig'

export const queryClient = new QueryClient({
	queryCache: new QueryCache({
		onError: (error, query) => {
			if (isDatadogLogsEnabled()) {
				datadogLogs.logger.error('[QueryCache] Query failed', {
					error: error.message,
					...(error instanceof ApiError && error.friendlyError
						? { friendlyError: error.friendlyError }
						: {}),
					queryKey: JSON.stringify(query.queryKey),
				})
			}
		},
	}),
	mutationCache: new MutationCache({
		onError: (error) => {
			if (isDatadogLogsEnabled()) {
				datadogLogs.logger.error('[MutationCache] Mutation failed', {
					error: error.message,
					...(error instanceof ApiError && error.friendlyError
						? { friendlyError: error.friendlyError }
						: {}),
				})
			}
		},
	}),
	defaultOptions: {
		queries: {
			staleTime: QUERY_STALE_TIMES.REALTIME,
			gcTime: QUERY_STALE_TIMES.LONG,
			retry: 1,
			refetchOnWindowFocus: false,
		},
		mutations: {
			retry: 0,
		},
	},
})
